import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import {useState, useCallback} from 'react'

import type {Props} from './AgentAuthDialog.types'
import DownloadConfig from './DownloadConfig/DownloadConfig'
import GenerateToken from './GenerateToken/GenerateToken'

import styles from './AgentAuthDialog.css'

enum Mode {
  TOKEN = 'token',
  CONFIG = 'config',
}
export default function AgentAuthDialog({onClose, defaultMode}: Props) {
  const [selectedMode, selectMode] = useState(defaultMode ?? Mode.TOKEN)
  const onTokenModeClick = useCallback(() => {
    selectMode(Mode.TOKEN)
  }, [selectMode])
  const onConfigModeClick = useCallback(() => {
    selectMode(Mode.CONFIG)
  }, [selectMode])
  return (
    <Dialog
      label="Generate auth token for agent"
      onCloseAttempt={onClose}
      showCloseButton
      show
      autoFocusFirst={false}
    >
      <Header>{'Generate auth token for agent'}</Header>
      <Content>
        <ButtonGroup>
          <Button onClick={onTokenModeClick} active={selectedMode === Mode.TOKEN}>
            {'Generate plain-text token'}
          </Button>
          <Button onClick={onConfigModeClick} active={selectedMode === Mode.CONFIG}>
            {'Download config'}
          </Button>
        </ButtonGroup>
        <div className={styles.dialogForm}>
          {selectedMode === Mode.TOKEN && <GenerateToken />}
          {selectedMode === Mode.CONFIG && <DownloadConfig />}
        </div>
      </Content>
    </Dialog>
  )
}
